<template lang="pug">
    div.article-preview.has-text-centered
        img.article-preview-image(:src="'https://bo.herdadesaomiguel.com/assets/news/' + article.image + '_' + size + '.jpg'")
        h3.is-size-11.is-uppercase.has-letter-spacing-200 {{ article.tag }} | {{ article.date }}
        h1.article-preview-title.is-size-25 {{ article.title }}
        h5.is-size-6 {{ article.subtitle }}
</template>

<script>
export default {
    name: 'news-article-preview',
    props: {
        article: Object,
        size: {
            type: String,
            default: 'medium'
        }
    }
}
</script>

<style scoped lang="stylus">
.article-preview
    &-title
        margin 1rem 0
        font-weight 500

        &:hover
            font-weight 600

    &-image
        margin-bottom 25px

</style>
